import React from "react";
import { compxLinks } from "../data/compxLinks";


function CompassLinks() {
  return (

<div style={{ marginTop: "8px", textAlign: "left" }}>

    
        <div style={{ marginTop: "8px" }}>Magnetic Variation (Declination) xx°</div>
        <a href={compxLinks.mvar} target="_blank" rel="noopener noreferrer">
          {compxLinks.mvar}
        </a>
        <div style={{ marginTop: "8px" }}>Pilot's Handbook of Aeronautical Knowledge</div>
        <a href={compxLinks.pilotsHndbk} target="_blank" rel="noopener noreferrer">
          {compxLinks.pilotsHndbk}
        </a>
        <div style={{ marginTop: "8px" }}>Airplane Flying Handbook</div>
        <a href={compxLinks.flyHndbk} target="_blank" rel="noopener noreferrer">
          {compxLinks.flyHndbk}
        </a>
        
      </div>
  );
}
   export default CompassLinks;